<template>
  <div class="selectBox" @click.stop>
    <div :class="disabled ? 'selectText disabledDom' : 'selectText'" @click="editShowList">
      <a-input v-model="text" :class="{inputFoucs: showList}" class="showList" disabled placeholder="请选择" />
      <span v-show="closeShow" class="closeStyle" @click.stop="removeData">×</span>
    </div>
    <div :class="showList ? 'selectList activeList' : 'selectList'">
      <div class="selectSearch">
        <a-input-search
          ref="searchValue"
          v-model="searchValue"
          placeholder="请输入关键字搜索"
          allow-clear
          @change="onSearchChange"
        />
      </div>
      <div v-show="list.length > 0" class="dataList">
        <div v-for="(li, i) in list" :key="i" @click="onChange(li)">
          <template v-if="!li.disabled">
            <p v-html="textFilter(li.label, li)">
            </p>
            <p v-if="li.subLabel" class="disable">计费条款: {{ li.subLabel }}</p>
          </template>
        </div>
      </div>
      <div v-show="list.length <= 0" class="nullData">暂无数据</div>
    </div>
  </div>
</template>

<script>

export default {
  model: {
    props: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    list: {
      type: Array,
      default: () => ([]),
    },
    edit: {
      type: Boolean,
      default: false,
    },
    selectAll: {
      type: Boolean,
      default: false,
    },
    tips: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    defaultSelect:{
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      showList: false,
      text: "",
      closeShow: false,
      searchValue: "",
      listItem: [],
      searchTimer: null
    };
  },
  computed: {},
  watch: {
    value: {
      handler(value){
        if(!this.selectAll){
          this.list.forEach((e) => {
            if(e.value.toString() === value.toString()){
              this.text = e.label
            }
          })
        }
        if(!value){
          this.text=''
        }
      },
      immediate: true
    },
    showList(val) {
      if (val) {
        this.$refs.searchValue.focus()
      }
    },
  },
  created() {
    this.listItem = this.list;
    if(this.defaultSelect){
      if(!this.edit && this.listItem.length > 0){
        if(this.listItem[0].disabled) {
          this.text = ''
          this.$emit('change', '')
          this.$emit("checkedList", {});
        } else {
          this.onChange(this.listItem[0])
        }
      }
    }
  },
  mounted() {
    window.addEventListener("click", () => {
      this.onshowList();
    });
  },
  methods: {
    textFilter(data, row){
      if(!this.tips) {
        return `${data.replace(this.searchValue, `<span style="color: red">${this.searchValue}</span>`)}${row.shipperName?`<span style="color: #ccc" >(${row.shipperName})</span>`:''} `
      }
      return `${data.replace(this.searchValue, `<span style="color: red">${this.searchValue}</span>`)}<p class="textTips">${row.stationNumber}个站点 预估里程${row.planMile ? row.planMile : 0}KM ${row.customerName}</p>`
    },
    onChange(data) {
      if (data.disabled) {
        return
      }
      this.text = data.label
      this.showList = false;
      this.$emit('change', data.value.toString())
      this.$emit("checkedList", data);
    },
    onSearchChange() {
      if(this.searchTimer) {
        this.clearTimer()
      }
      this.searchTimer = setTimeout(()=>{
        this.emitUpper()
        this.clearTimer()
      },1000)
    },
    clearTimer() {
      clearTimeout(this.searchTimer)
      this.searchTimer= null
    },
    emitUpper() {
      this.$emit('onSearch', this.searchValue)
    },
    onshowList() {
      this.showList = false;
      this.searchValue = "";
    },
    editShowList() {
      if(this.disabled) return
      this.showList = !this.showList;
      if(this.showList) {
        this.onSearchChange();
      }
    },
    removeData() {
      this.checkedList = [];
      this.text = "";
      this.checkAll = false;
      this.indeterminate = false
    },
  },
};
</script>

<style lang="less" scoped>
.selectBox {
  position: relative;
  .selectText {
    .inputFoucs {
      border-color: #25c48d;
    }
    &:hover{
      cursor: pointer;
    }
  }
  .selectList {
    z-index: 101;
    position: absolute;
    top: 40px;
    left: 0;
    width: 100%;
    height: 0;
    border: none;
    background-color: #fff;
    transition: all ease 0.3s;
    overflow: hidden;
    box-sizing: border-box;
    border-radius: 4px;
    .ant-input-search {
      vertical-align: top;
      margin-top: -1px;
    }
    .selectSearch {
      width: calc(100% + 2px);
      margin-left: -1px;
      /deep/ .ant-input {
        background: #f6f6f6;
        border: none;
      }
      /deep/ .ant-input:focus {
        box-shadow: initial !important;
        border-color: #c9c9c9 !important;
      }
    }
    .dataList {
      overflow: auto;
      height: calc(100% - 40px);
      >div:hover {
        background: #dff7eb;
      }
        p {
          margin: 0;
          padding: 0 10px;
          box-sizing: border-box;
          line-height: 30px;
          &.disable {
            color: #c0c4cc;
            font-size: 12px;
          }
        }
    }
    /deep/ .ant-checkbox-group {
      width: 100%;
    }
    /deep/ .ant-checkbox-group-item {
      font-size: 12px;
      width: 100%;
      height: 32px;
      line-height: 32px;
      padding: 0 20px;
      box-sizing: border-box;
      &:hover {
        background-color: #f5f5f5;
      }
    }
    .ant-checkbox-wrapper {
      padding: 0 20px;
      box-sizing: border-box;
      background-color: #fff;
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 10;
      box-shadow: 0 10px 10px 5px rgba(0, 0, 0, 0.3);
    }
    .nullData {
      color: #ccc;
      text-align: center;
    }
  }
  .activeList {
    height: 250px;
    border: 1px solid #d9d9d9;
  }
  .closeStyle {
    width: 12px;
    height: 12px;
    text-align: center;
    line-height: 11px;
    position: absolute;
    right: 10px;
    top: 11px;
    display: inline-block;
    background-color: rgba(0, 0, 0, 0.25);
    color: #fff;
    font-size: 12px;
    border-radius: 50%;
    &:hover {
      cursor: pointer;
      background-color: rgba(0, 0, 0, 0.65);
    }
  }
}
/deep/ .ant-input[disabled] {
  color: #323232 !important;
  background-color: #fff !important;
}
/deep/ .textTips{
  font-size: 12px;
  color: #ccc;
  margin-bottom: 5px;
  line-height: 12px;
}
.disabledDom{
  &:hover{
    cursor: no-drop !important;
  }
}
</style>
